import service from '@/utils/request'

export function getWareInPutawayPage(params) {
  const requestParams = {
    current: params?.current || 1,
    size: params?.size || 10,
    wareInStatus: params?.wareInStatus ?? 2,
    type: 1
  }

  if (params?.supplierId !== undefined && params?.supplierId !== null && params?.supplierId !== '') {
    requestParams.supplierId = params.supplierId
  }

  return service.get('/uic-system/api/warein/unload/page', {
    params: {
      ...requestParams
    }
  })
}

export function getWareInPutawayDetail(id) {
  return service.get('/uic-system/api/warein/detail', {
    params: {
      id
    }
  })
}

export function getWareListByParentId(params) {
  return service.get('/uic-system/api/warein/getWareListByParentId', {
    params: {
      id: params?.id,
      supplierId: params?.supplierId
    }
  })
}

export function unloadWareIn(data) {
  return service.post('/uic-system/api_hf/warein/unload', data)
}
